import type { City } from '../types/landing';

export const cities: City[] = [
  {
    slug: 'san-antonio',
    name: 'San Antonio',
    state: 'TX',
    neighborhoods: 'Stone Oak and Helotes to Schertz and the South Side',
    center: [29.4241, -98.4936],
    areas: [
      {
        id: 'sa-north',
        name: 'North Central San Antonio',
        communities: 'Stone Oak · Shavano Park · Hollywood Park',
        venues: [
          {
            id: 'hardberger-park',
            name: 'Hardberger Park',
            community: 'Shavano Park',
            address: '8400 NW Military Hwy, San Antonio, TX 78231',
            lat: 29.5617,
            lng: -98.5275,
            programs: [
              { id: 'p-101', sport: 'soccer', ages: '3–4', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'p-102', sport: 'soccer', ages: '5–6', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'p-103', sport: 'soccer', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'waitlist' },
              { id: 'p-104', sport: 'flag-football', ages: '6–8', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
            ],
          },
          {
            id: 'classen-steubing-ranch-park',
            name: 'Classen-Steubing Ranch Park',
            community: 'Stone Oak',
            address: '20220 Bulverde Rd, San Antonio, TX 78259',
            lat: 29.6239,
            lng: -98.4852,
            programs: [
              { id: 'p-111', sport: 'soccer', ages: '5–6', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'waitlist' },
              { id: 'p-112', sport: 'soccer', ages: '10–14', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
              { id: 'p-113', sport: 'flag-football', ages: '9–11', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
            ],
          },
        ],
      },
      {
        id: 'sa-northwest',
        name: 'Northwest San Antonio & Helotes',
        communities: 'Helotes · Leon Valley · Alamo Ranch',
        venues: [
          {
            id: 'raymond-russell-park',
            name: 'Raymond Russell Park',
            community: 'Helotes',
            address: '20644 W Interstate 10, San Antonio, TX 78257',
            lat: 29.6162,
            lng: -98.6098,
            programs: [
              { id: 'p-201', sport: 'soccer', ages: '3–4', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
              { id: 'p-202', sport: 'soccer', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
              { id: 'p-203', sport: 'flag-football', ages: '6–8', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'waitlist' },
            ],
          },
          {
            id: 'alamo-ranch-fields',
            name: 'Alamo Ranch Community Fields',
            community: 'Alamo Ranch',
            address: '5300 W Loop 1604 N, San Antonio, TX 78253',
            lat: 29.492,
            lng: -98.725,
            programs: [
              { id: 'p-211', sport: 'soccer', ages: '5–6', day: 'Saturdays', season: 'Spring 2027', starts: 'Mar 20', status: 'upcoming' },
              { id: 'p-212', sport: 'soccer', ages: '7–9', day: 'Saturdays', season: 'Spring 2027', starts: 'Mar 20', status: 'upcoming' },
            ],
          },
          {
            id: 'leon-valley-community-center',
            name: 'Leon Valley Community Center',
            community: 'Leon Valley',
            address: '6421 Evers Rd, Leon Valley, TX 78238',
            lat: 29.4955,
            lng: -98.613,
            programs: [
              { id: 'p-221', sport: 'basketball', ages: '5–6', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'p-222', sport: 'basketball', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
            ],
          },
        ],
      },
      {
        id: 'sa-northeast',
        name: 'Northeast San Antonio & Schertz-Cibolo',
        communities: 'Schertz · Cibolo · Live Oak · Universal City',
        venues: [
          {
            id: 'pickrell-park',
            name: 'Pickrell Park',
            community: 'Schertz',
            address: '703 Oak St, Schertz, TX 78154',
            lat: 29.58,
            lng: -98.2716,
            programs: [
              { id: 'p-301', sport: 'soccer', ages: '3–4', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
              { id: 'p-302', sport: 'soccer', ages: '5–6', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
              { id: 'p-303', sport: 'soccer', ages: '10–14', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
              { id: 'p-304', sport: 'flag-football', ages: '9–11', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
            ],
          },
          {
            id: 'live-oak-city-park',
            name: 'Live Oak City Park',
            community: 'Live Oak',
            address: '8101 Shin Oak Dr, Live Oak, TX 78233',
            lat: 29.56,
            lng: -98.336,
            programs: [
              { id: 'p-311', sport: 'soccer', ages: '3–4', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'waitlist' },
              { id: 'p-312', sport: 'soccer', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
            ],
          },
          {
            id: 'cibolo-rec-gym',
            name: 'Cibolo Recreation Gym',
            community: 'Cibolo',
            address: '200 S Main St, Cibolo, TX 78108',
            lat: 29.5615,
            lng: -98.227,
            programs: [
              { id: 'p-321', sport: 'basketball', ages: '3–4', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
              { id: 'p-322', sport: 'basketball', ages: '10–14', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'waitlist' },
            ],
          },
        ],
      },
      {
        id: 'sa-south',
        name: 'South San Antonio',
        communities: 'Southside · Brooks · Mission Reach',
        venues: [
          {
            id: 'southside-lions-park',
            name: 'Southside Lions Park',
            community: 'Southside',
            address: '3100 Hiawatha St, San Antonio, TX 78210',
            lat: 29.354,
            lng: -98.44,
            programs: [
              { id: 'p-401', sport: 'soccer', ages: '5–6', day: 'Saturdays', season: 'Spring 2027', starts: 'Mar 27', status: 'upcoming' },
              { id: 'p-402', sport: 'flag-football', ages: '6–8', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
            ],
          },
          {
            id: 'mission-county-park',
            name: 'Mission County Park',
            community: 'Mission Reach',
            address: '6030 Padre Dr, San Antonio, TX 78214',
            lat: 29.3333,
            lng: -98.47,
            programs: [
              { id: 'p-411', sport: 'soccer', ages: '3–4', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 24', status: 'open' },
              { id: 'p-412', sport: 'soccer', ages: '7–9', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 24', status: 'open' },
            ],
          },
        ],
      },
    ],
  },
  {
    slug: 'las-vegas',
    name: 'Las Vegas',
    state: 'NV',
    neighborhoods: 'Summerlin and Henderson to North Las Vegas',
    center: [36.1699, -115.1398],
    areas: [
      {
        id: 'lv-henderson',
        name: 'Henderson',
        communities: 'Green Valley · Anthem · Inspirada',
        venues: [
          {
            id: 'arroyo-grande-sports-complex',
            name: 'Arroyo Grande Sports Complex',
            community: 'Green Valley',
            address: '298 Arroyo Grande Blvd, Henderson, NV 89014',
            lat: 36.0326,
            lng: -115.063,
            programs: [
              { id: 'v-101', sport: 'soccer', ages: '3–4', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'v-102', sport: 'soccer', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'v-103', sport: 'flag-football', ages: '6–8', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
            ],
          },
          {
            id: 'cornerstone-park',
            name: 'Cornerstone Park',
            community: 'Henderson',
            address: '1600 Wigwam Pkwy, Henderson, NV 89074',
            lat: 36.0655,
            lng: -115.043,
            programs: [
              { id: 'v-111', sport: 'soccer', ages: '5–6', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'waitlist' },
            ],
          },
          {
            id: 'henderson-multigen-center',
            name: 'Henderson Multigenerational Center',
            community: 'Anthem',
            address: '250 S Green Valley Pkwy, Henderson, NV 89012',
            lat: 36.012,
            lng: -115.092,
            programs: [
              { id: 'v-121', sport: 'basketball', ages: '5–6', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
              { id: 'v-122', sport: 'basketball', ages: '7–9', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 16', status: 'open' },
            ],
          },
        ],
      },
      {
        id: 'lv-summerlin',
        name: 'Summerlin & Northwest',
        communities: 'Summerlin · Centennial Hills',
        venues: [
          {
            id: 'kellogg-zaher-sports-complex',
            name: 'Kellogg-Zaher Sports Complex',
            community: 'Summerlin',
            address: '7901 W Washington Ave, Las Vegas, NV 89128',
            lat: 36.24,
            lng: -115.295,
            programs: [
              { id: 'v-201', sport: 'soccer', ages: '5–6', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
              { id: 'v-202', sport: 'soccer', ages: '10–14', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
              { id: 'v-203', sport: 'flag-football', ages: '9–11', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'waitlist' },
            ],
          },
          {
            id: 'majestic-park',
            name: 'Majestic Park',
            community: 'Centennial Hills',
            address: '8501 W Deer Springs Way, Las Vegas, NV 89131',
            lat: 36.2585,
            lng: -115.3124,
            programs: [
              { id: 'v-211', sport: 'soccer', ages: '3–4', day: 'Saturdays', season: 'Spring 2027', starts: 'Mar 20', status: 'upcoming' },
              { id: 'v-212', sport: 'flag-football', ages: '6–8', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
            ],
          },
          {
            id: 'durango-hills-gym',
            name: 'Durango Hills Community Gym',
            community: 'Summerlin',
            address: '3521 N Durango Dr, Las Vegas, NV 89129',
            lat: 36.219,
            lng: -115.279,
            programs: [
              { id: 'v-221', sport: 'basketball', ages: '10–14', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 17', status: 'open' },
            ],
          },
        ],
      },
      {
        id: 'lv-north',
        name: 'North Las Vegas',
        communities: 'Aliante · Craig Ranch',
        venues: [
          {
            id: 'craig-ranch-regional-park',
            name: 'Craig Ranch Regional Park',
            community: 'Craig Ranch',
            address: '628 W Craig Rd, North Las Vegas, NV 89032',
            lat: 36.238,
            lng: -115.154,
            programs: [
              { id: 'v-301', sport: 'soccer', ages: '3–4', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 24', status: 'open' },
              { id: 'v-302', sport: 'soccer', ages: '7–9', day: 'Sundays', season: 'Winter 2027', starts: 'Jan 24', status: 'waitlist' },
              { id: 'v-303', sport: 'flag-football', ages: '6–8', day: 'Saturdays', season: 'Winter 2027', starts: 'Jan 23', status: 'open' },
            ],
          },
          {
            id: 'aliante-discovery-park',
            name: 'Aliante Discovery Park',
            community: 'Aliante',
            address: '2600 Nature Park Dr, North Las Vegas, NV 89084',
            lat: 36.286,
            lng: -115.196,
            programs: [
              { id: 'v-311', sport: 'flag-football', ages: '9–11', day: 'Saturdays', season: 'Spring 2027', starts: 'Mar 20', status: 'upcoming' },
            ],
          },
        ],
      },
    ],
  },
];
